<script>
import Base from '@/plans/ZOOM_WHITEBOARD/config/base';
import { isLastPlanTypeInPlantypeList } from '@/utils/index.js';
import { isFromShoppingCart, isProductCanRemove } from '@/views/config/shopping-cart/persist/plan-remove';

export default {
  extends: Base,
  computed: {
    canRmv() {
      if (this.$context.is.winback || this.$context.is.fromCampaignLink) {
        return !isLastPlanTypeInPlantypeList(
          this.planType,
          this.getSelectedPlans.map((p) => p.type),
        );
      }
      if (isFromShoppingCart()) {
        return isProductCanRemove(this.selectedPlan);
      }
      return this.$context.type !== this.planType;
    },
  },
};
</script>
